export default "__VITE_PUBLIC_ASSET__dc46185d__"